import React from "react";

export default function Catalogo({
  products,
  categories, // 1. Recebe as categorias dinâmicas do App.jsx
  activeFilter,
  onFilterChange,
  onOpenProduct,
  onToggleCart,
  isInCart,
}) {
  const filtroAtual = activeFilter || "todos";

  // Filtra a lista de produtos baseada no filtro selecionado
  const lista =
    filtroAtual === "todos"
      ? products
      : products.filter((produto) => produto.categoria === filtroAtual);

  return (
    <section className="secao-categorias" id="catalogo">
      <div className="secao-header">
        <span className="secao-etiqueta">Nosso Catálogo</span>
        <h2 className="secao-titulo">Produtos Exclusivos</h2>
      </div>

      <div className="filtros-categoria">
        {/* 2. Mapeia as categorias que vêm do banco de dados */}
        {categories &&
          categories.map((filtro) => (
            <button
              key={filtro.chave}
              className={`btn-filtro ${filtro.chave === filtroAtual ? "ativo" : ""}`}
              data-filtro={filtro.chave}
              type="button"
              onClick={() => onFilterChange(filtro.chave)}
            >
              {filtro.label}
            </button>
          ))}
      </div>

      <div className="grid-produtos" id="containerProdutos">
        {lista.map((produto, indice) => {
          const temFoto = produto.fotos && produto.fotos.length > 0;
          const imagemSrc = temFoto ? produto.fotos[0] : null;
          const precoOriginal = Number(
            produto.precoOriginal ?? produto.preco ?? 0,
          );
          const precoAtual = Number(produto.preco ?? 0);
          const temDesconto = precoOriginal > precoAtual;

          return (
            <article
              key={produto.id}
              className="card-produto produto-card"
              style={{ animationDelay: `${indice * 0.07}s` }}
              onClick={() => onOpenProduct(produto.id)}
            >
              <div className="card-imagem-wrapper">
                {temFoto ? (
                  <img
                    className="card-imagem"
                    src={imagemSrc}
                    alt={produto.nome}
                    loading="lazy"
                  />
                ) : (
                  <div className="card-placeholder">
                    <div className="card-placeholder-icone">
                      {produto.icone}
                    </div>
                    <div className="card-placeholder-texto">
                      Imagem em breve
                    </div>
                  </div>
                )}
                <span className="card-badge">{produto.categoriaLabel}</span>
                <div className="card-overlay">
                  <button
                    type="button"
                    className="btn-ver-produto"
                    onClick={(event) => {
                      event.stopPropagation();
                      onOpenProduct(produto.id);
                    }}
                  >
                    Ver produto
                  </button>
                </div>
              </div>

              <div className="card-corpo">
                <span className="card-categoria">{produto.categoriaLabel}</span>
                <h3 className="card-nome">{produto.nome}</h3>
                <p className="card-descricao">
                  {produto.descricao?.substring(0, 85)}...
                </p>
                <div className="card-rodape">
                  <div className="card-preco-group">
                    {temDesconto && (
                      <span className="card-preco-antigo">
                        R${" "}
                        {precoOriginal.toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                        })}
                      </span>
                    )}
                    <div className="card-preco">
                      <span>R$</span>
                      {precoAtual.toLocaleString("pt-BR", {
                        minimumFractionDigits: 2,
                      })}
                    </div>
                  </div>

                  <button
                    type="button"
                    className="btn-detalhes"
                    onClick={(event) => {
                      event.stopPropagation();
                      onOpenProduct(produto.id);
                    }}
                  >
                    Ver detalhes
                  </button>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
